import React, {useContext, useEffect} from "react";
import Header from "../../components/Header/Header";
import Camera from "./Camera/Camera";
import Chat from "./Chat/Chat";
import "./MainPage.css";
import UploadForm from "../../components/UploadForm/UploadForm";
import {CurrentUserContext} from "../../contexts/CurrentUserContext";

const MainPage = ({isLoggedIn}) => {

  const user = useContext(CurrentUserContext);
  useEffect(() => {
    /* console.log("user ID:", user?._id); */
  }, [user]);

  return (
    <div className="main-page">
      <Header isLoggedIn={isLoggedIn} />
      <div className="wrapper">
        <Camera isLoggedIn={isLoggedIn} />
        <Chat isLoggedIn={isLoggedIn} />
      </div>
      {/*  <UploadForm /> */}
    </div>
  );
};

export default MainPage;
